import React, { Component } from "react";
import "./Answers.css";
import { CustomInput, Input, FormGroup, Label } from "reactstrap";
import InputRange from "react-input-range";
import "react-input-range/lib/css/index.css";
import XmlNodeStringFormat from "./XmlNodeStringFormat";

export default class Answers extends Component {
  state = {
    answerResult: "",
    answerNode: ""
  };
  setNodeFormat = answer => {
    const { id, weight, description } = answer;
    return XmlNodeStringFormat.QuestionNode(
      this.props.question.id,
      id,
      weight,
      description
    );
  };

  setNode = answer => {
    let answerNode = this.setNodeFormat(answer);
    this.setState({ answerNode: answerNode, answerResult: answer.weight });
    this.props.onQuestionAnswered(this.props.question.id, answerNode);
  };

  pushAnswer = answer => {
    let answerNode = this.setNodeFormat(answer);
    answerNode = this.state.answerNode + " " + answerNode;
    this.setState({ answerNode });
    this.props.onQuestionAnswered(this.props.question.id, answerNode);
  };

  popAnswer = answer => {
    let answerNode = this.setNodeFormat(answer);
    let nodeState = this.state.answerNode;
    nodeState = nodeState.replace(answerNode, "").trim();
    this.setState({ answerNode: nodeState });
    this.props.onQuestionAnswered(this.props.question.id, nodeState);
  };

  onChecked = (e, answer) => {
    e.target.checked ? this.pushAnswer(answer) : this.popAnswer(answer);
  };

  answerType = (index, answer) => {
    const { conceptId, question } = this.props;
    switch (parseInt(question.type)) {
      case 1: //multiple
        return (
          <CustomInput
            type="checkbox"
            id={`awr-${conceptId}-${question.number}-${index + 1}`}
            name={`awr-${conceptId}-${question.number}`}
            label={answer.description}
            onChange={e => this.onChecked(e, answer)}
          />
        );
      case 0:
      case 2: // si o no
        return (
          <CustomInput
            type="radio"
            id={`awr-${conceptId}-${question.number}-${index + 1}`}
            name={`awr-${conceptId}-${question.number}`}
            label={answer.description}
            onChange={() => this.setNode(answer)}
          />
        );

      case 3: //rango
        this.state.answerResult === "" &&
          this.setNode({
            id: 0,
            weight: question.initialValue,
            description: question.initialValue
          });
        return (
          <>
            <InputRange
              id={`awr-${conceptId}-${question.number}-${index + 1}`}
              name={`awr-${conceptId}-${question.number}`}
              step={parseInt(question.increment)}
              maxValue={parseInt(question.weight)}
              minValue={0}
              value={parseInt(this.state.answerResult)}
              onChange={(value) =>
                this.setNode({
                  id: 0,
                  weight: value,
                  description: value
                })
              }
            />
            <Label for={`awr-${conceptId}-${question.number}-${index + 1}`}>
              {answer.description}
            </Label>
          </>
        );
      case 4: //textArea
        return (
          <>
            <Label for={`awr-${conceptId}-${question.number}-${index + 1}`}>
              {answer.description}
            </Label>
            <Input
              type="textarea"
              id={`awr-${conceptId}-${question.number}-${index + 1}`}
              name={`awr-${conceptId}-${question.number}`}
              value={this.setState.answerResult}
              onChange={e =>
                this.setNode({
                  id: answer.id,
                  weight: 0,
                  description: e.target.value
                })
              }
            />
          </>
        );
        default:
        break;
    }
  };

  render() {
    const { conceptId, answers, question } = this.props;
    return (
      <div>
        <FormGroup id={`formGroup-${conceptId}-${question.number}`}>
          {answers && answers.length > 0
            ? answers.map((answer, index) => (
                <>
                  <div key={index}>{this.answerType(index, answer.attributes)}</div>
                </>
              ))
            : this.answerType(1, "")}
        </FormGroup>
      </div>
    );
  }
}
